var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white border-1 rounded-xl shadow-md h-full",
    class: {
      'p-10 md:p-5 xl:p-8': _vm.position < 3,
      'md:grid md:grid-cols-2 md:space-x-4 md:p-0 col-span-2': _vm.position === 2,
      'bg-white md:bg-indigo-200 md:grid md:grid-cols-1 col-span-1 row-span-2': _vm.position === 3
    }
  }, [_vm.position > 1 ? _c('div', {
    staticClass: "relative hidden md:flex flex-col items-center",
    class: {
      'md:self-center md:py-0 xl:py-10': _vm.position === 3
    }
  }, [_c('illustration', {
    staticClass: "hidden md:block absolute bottom-2 md:bottom-2 xl:bottom-2 md:transform md:scale-60 lg:scale-70 xl:scale-80 xxl:scale-90 2xl:scale-x-100",
    attrs: {
      "name": "help",
      "height": "90%"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md:self-center flex flex-col space-y-4",
    class: {
      'md:col-span-1 pr-5 w-full h-full': _vm.position < 3,
      'bg-white col-span-full md:p-5 md:rounded-xl md:shadow-lg md:m-2': _vm.position === 3
    }
  }, [_c('div', {
    staticClass: "text-2xl md:text-xl xl:text-2xl font-normal w-full text-center md:text-left"
  }, [_vm._v("\n      Aide\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "overflow-y-auto hide-scroll-bar text-base flex flex-col space-y-5 justify-center",
    class: {
      'h-full': _vm.position < 3,
      'h-60 md:h-56 xl:h-64': _vm.position === 3
    }
  }, [_vm.$subscribed() ? _c('div', [_c('p', [_vm._v("\n          Pour obtenir de l’aide, vous pouvez nous contacter par téléphone :\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600"
  }, [_vm._v("\n          06 33 01 76 16\n        ")])]) : _vm._e(), _vm._v(" "), _vm.$subscribed() ? _c('p', [_vm._v("\n        Ou via le formulaire de contact\n      ")]) : _c('p', [_vm._v("\n        Pour obtenir de l’aide, vous pouvez nous contacter via le formulaire\n        de contact\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HelpContact'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Formulaire de contact",
      "uppercase": true,
      "icon": "plane",
      "right": true,
      "responsive": false,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }